<template>

  <v-container>
    <h1 class="text-center" v-if="loading">
      Chargement de la boutique
      <p class="font-weight-light">Merci de patienter quelques secondes.</p>
    </h1>
    <br/>
    <div ref="store" class="my-7"/>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card class="py-3">
        <v-img src="/gimc/storage/assets/card/popup.png?format=jpg&height=200" lazy-src="/gimc/storage/assets/card/popup.png?thumb=true" height="180px" contain></v-img>
        <v-card-title class="headline">Merci</v-card-title>
        <v-card-text>
          Pour que nos experts puissent réiventer votre jardin, un email va vous être envoyé pour décrire la suite des opérations.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import K from '../K'

export default {
  data: () => ({
    showOneProduct: '',
    showOneCategory: '',
    loading: true,
    dialog: false,
    instanceId: 'my-store-'+(new Date()).getTime()+'-'+Math.random().toString(36).slice(2,10)
  }),
  mounted () {
    if (typeof Ecwid !== 'undefined') {
      window.location = this.$route.path
      return
    }

    if (this.$route.name === 'ShopNoel') {
      this.showOneCategory = '120711251'
    }

    if (this.$route.params && this.$route.params.productId) {
      this.showOneProduct = this.$route.params.productId
    }

    this.$vuetify.goTo(0)
    this.$refs.store.id = this.instanceId
    const self = this

    let scriptLoader = document.createElement('script')
    scriptLoader.charset = 'utf-8'
    scriptLoader.src = 'https://app.ecwid.com/script.js?13907026&data_platform=code&data_date=2020-05-13'
    scriptLoader.onload = function () {
      xProductBrowser("categoriesPerRow=3","views=grid(20,3) list(60) table(60)","categoryView=grid","searchView=list","id="+self.instanceId)
  
      if (self.showOneProduct) {
        __openPage(self)
      } else if (self.showOneCategory) {
        __openPage(self)
      } else {
        self.loading = false
      }
      
      Ecwid.OnPageLoaded.add(function (page) {
        if (page.type === 'ORDER_CONFIRMATION') {
          __saveProject(page)
          self.$gtag.purchase({
            "transaction_id": page.vendorOrderNumber,
            "affiliation": "Ecwid",
            "value": 349
          })
   
          self.$gtag.event('conversion', {
            'send_to': 'AW-785651670/W0NoCOqh-tIBENav0PYC', 
            'transaction_id': page.vendorOrderNumber
          })

          self.$gtm.trackEvent({
            event: page.type, // Event type [default = 'interaction'] (Optional)
            category: 'ecwid',
            action: 'click',
            label: page.vendorOrderNumber,
            value: 349,
            // noninteraction: false // Optional
          })
          self.dialog = true
        } else {
          self.$gtm.trackEvent({
            event: page.type === 'PRODUCT' ? `${page.type}:${page.name}` : page.type, // Event type [default = 'interaction'] (Optional)
            category: 'ecwid',
            // noninteraction: false // Optional
          })
        }
      })

      document.body.removeChild(scriptLoader)
    }
    scriptLoader.onerror = function () {
      console.log('error')
    }
    document.body.appendChild(scriptLoader)
  }
}

function __openPage (self) {
  if (typeof Ecwid.openPage === 'undefined') {
    setTimeout(() => __openPage(self), 50)
  } else {
    self.loading = false

    // console.log("OPEN PAGE")
    // const page = {"type":"ORDER_CONFIRMATION","orderNumber":112,"vendorOrderNumber":"2016022","orderId":129863589,"hasPrevious":true}
    // __saveProject(page)
          
    setTimeout(() => {
      if (self.showOneCategory) {
        Ecwid.openPage('category', { id: self.showOneCategory })
      } else {
        Ecwid.openPage('product', { id: self.showOneProduct })
      }
    }, 150)
  }
}

function __saveProject (page) {
  let returnVal = {}
  let returnProject = {}
  const formStr = localStorage.getItem('form-done')
  try { returnVal = JSON.parse(formStr) } catch (e) {console.error(e)}
  const projectStr = localStorage.getItem(K.projectClient)
  try { returnProject = JSON.parse(projectStr) } catch (e) {console.error(e)}
  
  axios.post('/sky/web/project', {
    formStr: formStr,
    form: returnVal,
    host: window.location.hostname,
    uid: localStorage.getItem(K.userId),
    offer: localStorage.getItem(K.projectCurrent),
    project: returnProject,
    orderNumber: ''+page.orderNumber,
    vendorOrderNumber: ''+page.vendorOrderNumber,
    orderId: ''+page.orderId
  })
  .then(function (response) {
    console.log(response)
  })
  .catch(function (error) {
    console.log(error)
  })
}

</script>

